module.exports = __webpack_public_path__ + "static/media/VISA.6bfcfe9f.svg";